<template>
  <b-modal
    v-model="visible"
    title="Nuevo elemento para Recursos"
  >
    <b-form-group label="Nombre">
      <b-form-input
        type="text"
        placeholder="Nombre de la categoría"
        v-model="categoria.nombre"
        @keyup.enter="submit"
      />
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          @click="submit"
        >
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      visible: false,
      categoria: {
        id_padre: null,
        nombre: ''
      }
    }
  },

  methods: {
    ...mapActions(['fetchCategoriasRecursos']),
    async submit () {
      if (this.categoria.id) {
        await this.$api.patch('recursos/categoria/' + this.categoria.id, this.categoria).then(() => {
          this.$toast.success('Categoría actualizada.')
        })
      } else {
        await this.$api.post('recursos/categoria', this.categoria).then(() => {
          this.$toast.success('Categoría creada exitosamente')
        })
      }
      this.fetchCategoriasRecursos()
      this.visible = false
    }
  },
  watch: {
    visible (val) {
      if (val && this.categoria.id) {
        const id = this.categoria.id
        this.$api('recursos/categoria/' + id).then(res => {
          this.categoria = res.data
        })
      }
    }
  }
}
</script>
